import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://192.168.0.110:3001';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    if (error.response?.status === 403 && error.response?.data?.expired) {
      window.location.href = '/expired';
    }
    return Promise.reject(error);
  }
);

export default api;

// Barbearias
export const createBarbershop = (data) => api.post('/barbershops', data);
export const getBarbershop = (id) => api.get(`/barbershops/${id}`);
export const getBarbershopServices = (id) => api.get(`/barbershops/${id}/services`);
export const updateBarbershop = (id, data) => api.put(`/barbershops/${id}`, data);

// Agendamentos
export const getAvailableSlots = (barbershopId, data, servicoId) => 
  api.get(`/barbershops/${barbershopId}/horarios`, { params: { data, servico_id: servicoId } });
export const createAppointment = (data) => api.post('/barbearia/agendar', data);
export const getAppointments = (barbershopId, params) => 
  api.get(`/agendamentos/${barbershopId}`, { params });
export const cancelAppointment = (id) => api.delete(`/agendamento/${id}`);

// Upload de logo
export const uploadLogo = (barbershopId, file) => {
  const formData = new FormData();
  formData.append('logo', file);
  return api.post(`/upload/logo/${barbershopId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteLogo = (barbershopId) => api.delete(`/upload/logo/${barbershopId}`);

export const uploadBarberPhoto = (barbershopId, file, barberId = null) => {
  const formData = new FormData();
  formData.append('photo', file);
  if (barberId) formData.append('barberId', barberId);
  return api.post(`/upload/barber-photo/${barbershopId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateAppointmentStatus = (id, status) => 
  api.put(`/agendamento/${id}/status`, { status });

// Auth
export const login = (slug, senha) => api.post('/auth/login', {
  slug,
  username: slug,
  id: slug,
  senha
});
export const checkBillingStatus = () => api.get('/auth/billing-status');

export { API_URL };
